import React, { useState } from "react";
import { TimeOptions, TimeOptionsLabel } from "./constants";
import { LucketItem } from "./lucket/LucketItem.cmp";
import { calculateTimeSlot } from "./slice/lucket-model/model";
const reorderedTimeOptions = [
  TimeOptions[2], // Early Morning
  TimeOptions[3], // Morning
  TimeOptions[4], // Noon
  TimeOptions[5], // Afternoon
  TimeOptions[6], // Evening
  TimeOptions[7], // Night
  TimeOptions[0], // Late Night
  TimeOptions[1]  // Dawn
];
const reorderedTimeOptionsLabel = [
  TimeOptionsLabel[2], // Early Morning
  TimeOptionsLabel[3], // Morning
  TimeOptionsLabel[4], // Noon
  TimeOptionsLabel[5], // Afternoon
  TimeOptionsLabel[6], // Evening
  TimeOptionsLabel[7], // Night
  TimeOptionsLabel[0], // Late Night
  TimeOptionsLabel[1]  // Dawn
];

export function AllTimes({ filteredBuckets, open, setOpen }) {
  // Reorder TimeOptions and TimeOptionsLabel to start at Early Morning and end at Dawn


  return reorderedTimeOptions.map((option, i) => {
    let currentLuckets = filteredBuckets && filteredBuckets.filter(l => l.time && l.time[option]);
    return <BucketsForTime currentLuckets={currentLuckets} i={i} option={option} open={open} setOpen={setOpen} />
  });
}

function BucketsForTime({ currentLuckets, i, option, setOpen, open }) {
  console.log(open, "hi open times");
  let defaultOpen = calculateTimeSlot((new Date())) == option;
  function setOpenTime() {
    setOpen({ ...open, [option]: !open[option] });
  }
  return <div>
    <div
      className="timeframedoLucket"
      style={{ fontWeight: defaultOpen && "bold" }}
      onClick={setOpenTime}>
      {reorderedTimeOptionsLabel[i]} - {defaultOpen && "Now "}
      {currentLuckets && `(${currentLuckets.length})`}
    </div>
    {open[option] && currentLuckets && <div>
      {currentLuckets.map((lucket, i) => {
        return <LucketItem lucket={lucket} />
      })}
    </div>}
  </div>
}